
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/dedicated-teams",
      function () {
        return require("private-next-pages/services/dedicated-teams/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/dedicated-teams"])
      });
    }
  